export const MODAL = {
  NONE: 'none',
  ADD_REMOVE_COMPANY: 'addRemoveCompany',
  REGISTRATION: 'registration',
  ADD_TO_WATCHLISTS_MODAL: 'add-to-watchlists-modal',
  COMPANY_LIMIT_MODAL: 'company-limit-modal',
  PLANS: 'plans',
} as const;
